
export interface BackgroundWaveColor {
  bottom: string,
  l1: string,
  l2: string,
  l3: string,
  top: string,
}

const FocusColor: BackgroundWaveColor = {
  bottom: "var(--color-timer-focus-bottom)",
  l1: 'var(--color-timer-focus-l1)',
  l2: 'var(--color-timer-focus-l2)',
  l3: 'var(--color-timer-focus-l3)',
  top: 'var(--color-timer-focus-top)'
};

const ShortBreakColor: BackgroundWaveColor = {
  bottom: "var(--color-timer-short-break-bottom)",
  l1: "var(--color-timer-short-break-l1)",
  l2: "var(--color-timer-short-break-l2)",
  l3: "var(--color-timer-short-break-l3)",
  top: "var(--color-timer-short-break-top)"
};

const LongBreakColor: BackgroundWaveColor = {
  bottom: "var(--color-timer-long-break-bottom)",
  l1: "var(--color-timer-long-break-l1)",
  l2: "var(--color-timer-long-break-l2)",
  l3: "var(--color-timer-long-break-l3)",
  top: "var(--color-timer-long-break-top)"
};

export const colorArray: BackgroundWaveColor[] = [FocusColor, ShortBreakColor, LongBreakColor]